(function() {
    let btn = window.document.querySelector('.navbar-toggler-custom'),
        menu = window.document.querySelector(btn.dataset.target);

    if (!btn) {
        return;
    }

    btn.addEventListener('click', () => {
        if (btn.classList.contains('active')) {
            btn.classList.remove('active');
            menu.classList.add('collapsed');
            window.document.body.style.overflow = 'auto';

            return;
        }

        btn.classList.add('active');
        menu.classList.remove('collapsed');

        if (window.document.documentElement.clientWidth < 576) {
            window.document.body.style.overflow = 'hidden';
        }
    });

    if (window.document.documentElement.clientWidth < 992) {
        menu.addEventListener('click', (e) => {
            if (e.target.tagName !== "A") {
                return;
            }

            if (menu.classList.contains('collapsed')) {
                return;
            }

            window.document.body.style.overflow = 'auto';
            btn.classList.remove('active');
            menu.classList.add('collapsed');
        });
    }
})();